import axios from "../axiosInstance"

export interface CleaningEmployee {
  id: number
  name: string
  jobTitle: string
  reason: string
}

export const confirmEmployeeCleaning = async (
  companyId: number,
  employees: CleaningEmployee[]
): Promise<{ excludedCount: number }> => {
  const res = await axios.post<{ excludedCount: number }>("/employees/clean/confirm", { companyId, employees })
  return res.data
}

export interface DuplicateGroupParsed {
  groupId: number
  confidence: "high" | "medium" | "low"
  reason: string
  primary: { id: number; name: string; jobTitle: string }
  duplicates: { id: number; name: string; jobTitle: string }[]
}

export const confirmEmployeeDuplicates = async (
  companyId: number,
  duplicates: { id: number; name: string; jobTitle: string; groupId: number }[]
): Promise<{ deduplicatedCount: number }> => {
  const res = await axios.post<{ deduplicatedCount: number }>("/employees/dedupe/confirm", { companyId, duplicates })
  return res.data
}

export const updateEmployeeMiscCode = async (eventId: number, miscCode: string | null): Promise<void> => {
  await axios.post("/employees/misc-code", { eventId, miscCode })
}

export const updateEmployeeLocation = async (eventId: number, location: string | null): Promise<void> => {
  await axios.post("/employees/location", { eventId, location })
}

export const bulkUpdateEmployeeLocations = async (updates: { eventId: number; location: string | null }[]): Promise<{ successCount: number; failedCount: number }> => {
  const res = await axios.post("/employees/location/bulk", { updates })
  return res.data
}

export const getDepartedEmployees = async (companyId: number) => {
  const res = await axios.get(`/employees/departed/${companyId}`)
  if (!res.data.success) throw new Error("Failed to fetch departed employees")
  return res.data.employees
}

export const getEmployeesByCompany = async (companyId: number) => {
  try {
    const res = await axios.get(`/employees/all/${companyId}`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch employees")
    }

    const {
      employees,
      generalAttrition,
      salesAttrition,
      salesCount,
      engineeringCount,
      monthlyHiresAndDepartures
    } = data

    return {
      employees,
      generalAttrition,
      salesAttrition,
      salesCount,
      engineeringCount,
      monthlyHiresAndDepartures
    }
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw error
  }
}